import './MenuListPage.less';

export const prefix = 'oc-p-menu-list';

export { default } from './MenuListPage';